import { useLenis } from "@/lib/useLenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import WhoWeAre from "@/components/site/WhoWeAre";
import WhatWeBuild from "@/components/site/WhatWeBuild";
import Categories from "@/components/site/Categories";
import WhoWeServe from "@/components/site/WhoWeServe";
import Why from "@/components/site/Why";
import GetInvolved from "@/components/site/GetInvolved";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  return (
    <main data-testid="landing-page" className="bg-[#F8F9FA] text-[#111111]">
      <Navbar />
      <Hero />
      <WhoWeAre />
      <WhatWeBuild />
      <Categories />
      <WhoWeServe />
      <Why />
      <GetInvolved />
      <Footer />
    </main>
  );
}
